import React from "react";
import { BsEmojiSmile } from "react-icons/bs";
import { GiTwoCoins } from "react-icons/gi";
import { FaRegSadTear } from "react-icons/fa";

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Link } from "react-router-dom";
const index = ({ data, isApp }) => {
  const HandlerScore = () => {
    let resylt = data.data.total_price / data.score["basedofscororder"];
    if (data.data.status == "peyed") {
      return (
        <div className="score">
          <GiTwoCoins style={{ fontSize: "22px", marginLeft: "5px" }} />
          <span>
            {resylt.toFixed(0) * data.score["scorforbased"]} امتیاز به امتیازات
            شما اضافه شد
          </span>
        </div>
      );
    }
  };
  const HandlerText = () => {
    switch (data.data.status) {
      case "peyed":
        return (
          <div className="message-ok">
            <BsEmojiSmile style={{ fontSize: "22px", marginLeft: "5px" }} />
            <span>پرداخت شما با موفقیت انجام شد</span>
          </div>
        );
      default:
        return (
          <>
            <div className="message-error">
              <FaRegSadTear style={{ fontSize: "22px", marginLeft: "5px" }} />
              <span>{data.data.bankmessage}</span>
            </div>
            <div className="message-error">
              <span>
                در صورت کسر وجه از حسابتان تا وجه کسر شده تا 24 ساعت آینده به
                حسابتان باز میگردد
              </span>
            </div>
          </>
        );
    }
  };
  const Handlerbtn = () => {
    if (data.app == "true") {
      switch (data.data.status) {
        case "peyed":
          return (
            <>
              {data.data.model_order != "walletsharge" ? (
                <Link
                  to={"/ticket?pay=" + data.paykey}
                  className="btn bg-success mb-1"
                  style={{ color: "white" }}
                >
                  چاپ بلیت
                </Link>
              ) : (
                <></>
              )}
              <a
                href="app://nikotan"
                className="btn bg-success mb-1"
                style={{ color: "white" }}
              >
                بازگشت به اپ
              </a>
            </>
          );
          break;
        default:
          return (
            <a
              href="app://nikotan"
              className="btn btn-danger mb-1"
              style={{ color: "white" }}
            >
              بازگشت به اپ
            </a>
          );
          break;
      }
    } else {
      switch (data.data.status) {
        case "peyed":
          return (
            <>
              {data.data.model_order != "walletsharge" ? (
                <Link
                  to={"/ticket?pay=" + data.paykey}
                  className="btn bg-success mb-1"
                  style={{ color: "white" }}
                >
                  چاپ بلیت
                </Link>
              ) : (
                <></>
              )}
              <Link
                to={isApp ? "/dashboard" : "/User/Dashboard"}
                className="btn bg-success mb-1"
                style={{ color: "white" }}
              >
                بازگشت به داشبورد
              </Link>
            </>
          );
          break;
        default:
          return (
            <Link
              to={isApp ? "/dashboard" : "/User/Dashboard"}
              className="btn btn-danger mb-1"
              style={{ color: "white" }}
            >
              بازگشت به داشبورد
            </Link>
          );
          break;
      }
    }
  };
  return (
    <div className="box">
      <div className="row head-box">
        <img src={window.origin + "/img/logo.png"} alt="" />
        <span>سامانه معرفی، اطلاع رسانی و رزرو آنلاین مجموعه های ورزشی </span>
      </div>
      <hr />
      {HandlerText()}
      {HandlerScore()}
      <div className="main row">
        <div className="col-6">
          <div className="d-flex justify-content-start align-items-center">
            <IoMdCheckmarkCircleOutline
              style={{ fontSize: "22px", marginLeft: "5px" }}
            />
            <span>مبلغ : </span>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <span style={{ fontWeight: "400" }}>
              {data.data.total_price} تومان
            </span>
          </div>
        </div>
        <div className="col-6">
          <div className="d-flex justify-content-start align-items-center">
            <IoMdCheckmarkCircleOutline
              style={{ fontSize: "22px", marginLeft: "5px" }}
            />
            <span>شماره پیگیری : </span>
          </div>
          <div className="d-flex justify-content-end align-items-center">
            <span style={{ fontWeight: "400" }}>
              {data.data.trackingcode != null
                ? data.data.trackingcode
                : "ثبت نشده است"}{" "}
            </span>
          </div>
        </div>
        {data && data.data && data.data.type_payment == "gateway" ? (
          <>
            <div className="col-6 mt-2">
              <div className="d-flex justify-content-start align-items-center">
                <IoMdCheckmarkCircleOutline
                  style={{ fontSize: "22px", marginLeft: "5px" }}
                />
                <span>شمار تراکنش : </span>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <span style={{ fontWeight: "400" }}>{data.data.transid} </span>
              </div>
            </div>
            <div className="col-6 mt-2">
              <div className="d-flex justify-content-start align-items-center">
                <IoMdCheckmarkCircleOutline
                  style={{ fontSize: "22px", marginLeft: "5px" }}
                />
                <span>شماره ارجاع : </span>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <span style={{ fontWeight: "400" }}>{data.data.ref_id} </span>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="btns">
        {/* <button className='btn bg-success mb-2'>asdasd</button>
                <button className='btn bg-success'>asdasd</button> */}
        {Handlerbtn()}
      </div>
      <div className="foot">
        <div>
          <span>از حسن انتخاب شما سپاسگزاریم</span>
        </div>
        <div>
          <span style={{ color: "#E42A3F" }}>نیکوتن،</span>
          <span> همراه همیشگی سلامت شما</span>
        </div>
      </div>
    </div>
  );
};

export default index;
